// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// mui
import { Alert, AlertProps, Button } from '@mui/material';

// props
export const IfrAlertTypes = ['IFR_PLAN_NON_EXISTENT'] as const;
export type IfrAlertType = (typeof IfrAlertTypes)[number];
export interface IfrAlertProps {
	type: IfrAlertType;
}

export const IfrAlert = ({ type }: IfrAlertProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// vars
	let action: AlertProps['action'];
	let message;
	let severity: AlertProps['severity'] = 'info';

	if (type === 'IFR_PLAN_NON_EXISTENT') {
		action = (
			<Button
				color="inherit"
				component={RouterLink}
				size="small"
				to={`/project/${project?.idWbg}/reports/financial/plans?dialog=addPlan`}
				variant="outlined">
				Add Plan
			</Button>
		);
		message = t('alert.ifrFinalizedPlanNonExistent');
		severity = 'warning';
	}

	return (
		<Alert
			action={action}
			severity={severity}
			sx={{ display: 'flex', alignItems: 'center' }}
			variant="outlined">
			{message}
		</Alert>
	);
};
